import BaseService from './BaseService';

class AuthenticationService extends BaseService {
    login = (data) => this.post('/login/agency', data);

    logout = () => this.get('/agency/logout');
}

export default new AuthenticationService();
